<template>
    <!-- 系统首页 -->
    <div>
        <el-row :gutter="20">
            <el-col class="quick">
                <el-card shadow="hover" style="height: 315px">
                    <div slot="header" class="clearfix">
                        <span style="font-size: 18px">快捷入口</span>
                    </div>
                    <div class="quick-access">
                        <div :class="getBackground.backgroundColor" class="access-item-default" @click="toPath('/substituteDrivingOrder')">
                            <div>
                                <img src="../../assets/img/order.png" alt="" />
                            </div>
                            <p>订单监控</p>
                        </div>
                        <div :class="getBackground.backgroundColor" class="access-item-default" @click="toPath('/driver')">
                            <div>
                                <img src="../../assets/img/driver.png" alt="" style="width: 60px; height: 60px" />
                            </div>
                            <p>司机管理</p>
                        </div>
                        <div :class="getBackground.backgroundColor" class="access-item-default" @click="toPath('/user')">
                            <div>
                                <img src="../../assets/img/user.png" alt="" />
                            </div>
                            <p>乘客信息</p>
                        </div>
                        <div :class="getBackground.backgroundColor" class="access-item-default" @click="toPath('/labelLists')">
                            <div>
                                <img src="../../assets/img/label.png" alt="" />
                            </div>
                            <p>标签管理</p>
                        </div>
                        <div :class="getBackground.backgroundColor" class="access-item-default" @click="toPath('/advertInformation')">
                            <div>
                                <img src="../../assets/img/advertInformation.png" alt="" />
                            </div>
                            <p>广告库</p>
                        </div>
                        <div :class="getBackground.backgroundColor" class="access-item-default" @click="toPath('/article')">
                            <div>
                                <img src="../../assets/img/article.png" alt="" />
                            </div>
                            <p>公告</p>
                        </div>
                    </div>
                </el-card>
            </el-col>

            <el-col style="width: 280px">
                <el-card shadow="hover" style="height: 315px">
                    <div class="user-info">
                        <div class="user-info-cont">
                            <div class="user-info-name">{{ userData.name }}</div>
                        </div>
                    </div>
                    <div class="user-info-list">
                        <span>绑定号码:</span>

                        <span>{{ userData.phone }}</span>
                    </div>
                    <div class="user-info-list">
                        <span>所属城市:</span>

                        <span class="city-main">{{ userData.city.name }}</span>
                    </div>
                    <div class="user-info-list">
                        <span>状态:</span>

                        <span>
                            <el-tag :type="userData.status.val == '0' ? 'warning' : userData.status.val == '2' ? 'danger' : ''">
                                {{ userData.status.alias }}</el-tag
                            >
                        </span>
                    </div>
                    <div class="user-info-list">
                        <span>验证状态:</span>

                        <span>
                            <el-tag :type="userData.verify.val == '1' ? 'warning' : ''">{{ userData.verify.alias }}</el-tag>
                        </span>
                    </div>
                    <div class="user-info-list">
                        <span>锁定状态:</span>

                        <span>{{ userData.locking.alias }}</span>
                    </div>

                    <div class="user-info-list">
                        <span> 注册时间:</span>

                        <span>{{ userData.reg_time.Ymd }}</span>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="24">
                <el-card shadow="hover">
                    <div>
                        <div style="text-align: center; margin: 10px 0">
                            <span>城市:</span>
                            <span>{{ userData.city.name }}</span>
                        </div>

                        <div class="statistics-box-head" style="margin: 10px 0">
                            <span>日期 : </span>

                            <!-- <el-date-picker v-model="search_data.day_time" type="date" placeholder="选择日期"
                                format="yyyy-MM-dd" value-format="yyyy-MM-dd" style="width: 150px;" clearable>
                            </el-date-picker> -->
                            <el-date-picker
                                v-model="search_time"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @change="timeChange"
                                style="width: 280px; margin-left: 10px"
                            >
                            </el-date-picker>
                        </div>
                        <div class="statistics-box-head" style="margin: 10px 0">
                            <span style="display: inline-block; width: 90px; text-align: right; margin-right: 5px">模式 : </span>
                            <el-select
                                v-model="search_data.type"
                                placeholder="请选择模式"
                                style="width: 200px; margin-right: 20px; margin-left: 10px"
                                clearable
                            >
                                <el-option label="下单时间" value="0"></el-option>
                                <el-option label="完成时间" value="1"></el-option>
                            </el-select>
                        </div>

                        <div style="display: flex; justify-content: center; height: 32px; margin: 10px 0">
                            <el-button style="padding: 8px 10px" @click="searchStatistics">确定</el-button>

                            <el-button style="padding: 8px 10px" type="warning" @click="toOrderStatistics">详情 </el-button>
                        </div>
                    </div>

                    <div :class="getBackground.btnColo" class="statistics-box-main">
                        <div style="margin: 0 20px">
                            <span>总单量</span>
                            <p>{{ order_data.count }}</p>
                        </div>

                        <div style="margin: 0 20px">
                            <span>总金额</span>
                            <p>{{ order_data.finish_amount }}</p>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 二维码和公告 -->
        <div class="content-bottom">
            <!-- <div class="ewCodeNotify">
                <div style="width: 100%">
                    <div>
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img src="../../assets/img/Lark20200520-181803.png" alt="" />
                                <p>安卓司机端下载</p>
                            </div>
                        </el-card>
                    </div>
                    <div style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img src="../../assets/img/ios-driver.png" alt="" />
                                <p>苹果司机端下载</p>
                            </div>
                        </el-card>
                    </div>
                </div>
                <div style="width: 100%; margin-left: 10px">
                    <div>
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img src="../../assets/img/ios-user.png" alt="" />
                                <p>苹果乘客端下载</p>
                            </div>
                        </el-card>
                    </div>
                    <div style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img src="../../assets/img/Lark20200519-132751.jpeg" alt="" />
                                <p>小程序二维码</p>
                            </div>
                        </el-card>
                    </div>
                </div>
            </div> -->
            <!-- 不同项目展示不同二维码图片 只需要在计算属性getBackground方法中把driverAndroid动态改成jiuzhou  ma ling bai  -->
            <!-- 同时需要把对应项目的二维码图片放到对应路径下并按下面代码命名规则去命名，比如羚师傅的安卓司机端就是ling-driver-android.png -->
            <div class="ewCodeNotify">
                <div style="width: 100%">
                    <div>
                        <el-card shadow="hover">
                            <div style="text-align: center">
                          
                          
                                <img
                                    :src="require(`@/assets/img/${getBackground.driverAndroid}-driver-android.png`)"
                                    alt=""
                                    style="width: 200px; height: 200px"
                                />
                                <p>安卓司机端下载</p>
                            </div>
                        </el-card>
                    </div>
                    <div style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img
                                    :src="require(`@/assets/img/${getBackground.driverAndroid}-driver-ios.png`)"
                                    alt=""
                                    style="width: 200px; height: 200px"
                                />
                                <p>苹果司机端下载</p>
                            </div>
                        </el-card>
                    </div>
                </div>
                <div style="width: 100%; margin-left: 10px">
                    <div>
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img
                                    :src="require(`@/assets/img/${getBackground.driverAndroid}-user-ios.png`)"
                                    alt=""
                                    style="width: 200px; height: 200px"
                                />
                                <p>苹果乘客端下载</p>
                            </div>
                        </el-card>
                    </div>
                    <div style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img
                                    :src="require(`@/assets/img/${getBackground.driverAndroid}-user-weixin.png`)"
                                    alt=""
                                    style="width: 200px; height: 200px"
                                />
                                <p>小程序二维码</p>
                            </div>
                        </el-card>
                    </div>
                </div>
            </div>

            <!-- 白师傅没有苹果端二维码，用下面的代码，将来有苹果端二维码以后，下面代码就用不上了，直接用上面代码即可 -->
              <!-- <div class="ewCodeNotify">
                <div style="width: 100%">
                    <div>
                        <el-card shadow="hover">
                            <div style="text-align: center">
                          
                          
                                <img
                                    :src="require(`@/assets/img/${getBackground.driverAndroid}-driver-android.png`)"
                                    alt=""
                                    style="width: 200px; height: 200px"
                                />
                                <p>安卓司机端下载</p>
                            </div>
                        </el-card>
                    </div>
                   <div style="margin-top: 10px">
                        <el-card shadow="hover">
                            <div style="text-align: center">
                                <img
                                    :src="require(`@/assets/img/${getBackground.driverAndroid}-user-weixin.png`)"
                                    alt=""
                                    style="width: 200px; height: 200px"
                                />
                                <p>小程序二维码</p>
                            </div>
                        </el-card>
                    </div>
                </div>
            
            </div> -->
            <div class="ewCodeNotify">
                <el-card class="right-card">
                    <div class="notify">更新通知</div>

                    <div class="notify-dash" v-for="item in dataNotice" :label="item.notice_id" :key="item.notice_id">
                        <div class="notify-content">
                            <div style="margin-right: 10px">
                                <el-tag :type="item.status == '0' ? 'danger' : 'success'">
                                    {{ item.status == '1' ? '已读' : '未读' }}</el-tag
                                >
                            </div>
                            <el-popover class="notify-time" placement="top-start" trigger="hover" :content="item.time_stamp">
                                <div class="notify-time-div" slot="reference">{{ item.time_stamp }}</div>
                            </el-popover>
                            <el-popover class="notify-title" placement="top-start" trigger="hover" :content="item.title">
                                <div class="notify-time-div" slot="reference">{{ item.title }}</div>
                            </el-popover>
                        </div>

                        <div class="notify-btn">
                            <el-button type="primary" @click="detailsNotify(item.notice_id)">查看详情</el-button>
                        </div>
                    </div>

                    <!-- element ui 原生分页组件 -->
                    <div class="pagination">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="search_data_notify.page"
                            :page-sizes="[5, 20, 30, 40, 50]"
                            :page-size="search_data_notify.limit"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="result_data.count"
                        >
                        </el-pagination>
                    </div>

                    <!-- 通知详情 -->
                    <detailsNotify :isShow="detailsNotify_isShow" :data="notice_id" @onSubmit="adminNoticeLists"></detailsNotify>
                </el-card>
            </div>
        </div>

        <!-- 更新内容组件 -->
        <updateCont :isShow="updateCont_show"></updateCont>
    </div>
</template>

<script>
import { config } from '@/utils/config'; //配置
import updateCont from '../common/updateCont';
import detailsNotify from './detailsNotify.vue';
var _this;
export default {
    name: 'dashboard',
    components: {
        detailsNotify,
        updateCont
    },
    computed: {
        // 根据config配置文件的项目名称动态改变首页快捷入口背景色以及 总单量总金额按钮颜色
        getBackground() {
            switch (config.proType) {
                case '九州':
                   
                    return { backgroundColor: 'access-item', 
                    btnColo: 'statistics-box-main',
                    driverAndroid : 'jiuzhou',
   
                    
                  };
                case '马上':
                    return { backgroundColor: 'access-item-ma', btnColo: 'ma-box-main',
                      driverAndroid : 'jiuzhou' };
                case '羚师傅':
                    return { backgroundColor: 'access-item-ling', btnColo: 'ling-box-main',
                      driverAndroid : 'jiuzhou' };
                case '白师傅':
                    return { backgroundColor: 'access-item-bai', btnColo: 'bai-box-main',
                      driverAndroid : 'bai' };
                      // 白师傅现在没有苹果端二维码，文件夹里是复制了多个安卓司机端
                case '青鸟':
                    return { backgroundColor: 'access-item-bird', btnColo: 'bird-box-main',
                      driverAndroid : 'jiuzhou' };
                   
            }
        }
    },
    data() {
        return {
            driverAndroid:'',
            proName: config.proType,
            // 存放表格数据
            tableData: [],
            result_data: {},
            notice_id: '',
            detailsNotify_isShow: false,
            dataNotice: [],
            userData: JSON.parse(localStorage.getItem('login')),

            updateCont_show: false,

            search_time: '',

            order_data: {
                count: 0,
                finish_amount: 0
            },

            // 下拉搜索城市
            value_city_code: '',
            options_city_code: [],
            city_options_data: {
                page: 1,
                limit: 50,
                name: ''
            },

            search_data: {
                fixed_array: '',
                type: ''
            },
            search_data_notify: {
                page: 1,
                limit: 5
            }
        };
    },

    created() {
        _this = this;
        this.fetchImageUrl();
        // 获取首页更新通知
        _this.adminNoticeLists();
        //     this.handleListener();
        //     this.changeDate();
        // },
        // activated() {
        //     this.handleListener();
        // },
        // deactivated() {
        //     window.removeEventListener('resize', this.renderChart);
        //     bus.$off('collapse', this.handleBus);
    },
    methods: {
          fetchImageUrl() {
      // 假设这是一个异步获取图片URL的函数
      // 这里可以是API调用或其他逻辑来获取图片URL
      this.imageUrl = 'http://example.com/path/to/image.jpg';
    },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data_notify.limit = val;

            //初始化列表
            _this.pages_function();
        },
        //页码变化
        handleCurrentChange(val) {
            console.log(val, 'val页码变化');
            _this.search_data_notify.page = val;
            console.log(_this.search_data_notify.page, '_this.search_data_notify.page');
            //初始化列表
            _this.pages_function();
        },
        //翻页组件的回调
        pages_function() {
            console.log('翻页组件回调');
            //初始化列表
            _this.adminNoticeLists();
        },

        // 获取首页更新通知
        adminNoticeLists() {
            _this
                .$post('/notice/adminNoticeLists', _this.search_data_notify)
                .then((res) => {
                    _this.dataNotice = res.data;
                    _this.result_data = res;
                    _this.tableData = res.data;
                })
                .catch((err) => {});
        },

        // 查看更新通知详情
        detailsNotify(notice_id) {
            _this.detailsNotify_isShow = !_this.detailsNotify_isShow;
            _this.notice_id = notice_id;
        },

        // 首页，输入日期和模式，跳转到统计-订单统计页面
        toOrderStatistics() {
            this.$router.push({
                path: '/orderStatistics'
            });
        },

        // 选择日期
        timeChange(val) {
            if (val != null) {
                _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.fixed_array = '';
            }
        },

        // 选择日期和模式点击确定按钮
        searchStatistics() {
            _this
                .$post('/statistics/getOrderHomeCount', _this.search_data)
                .then((res) => {
                    _this.order_data = res.data;
                })
                .catch((err) => {});
        },

        // 快捷菜单跳转路由
        toPath(path) {
            var navLists = JSON.parse(sessionStorage.getItem('navBar'));

            for (var i = 0; i < navLists.length; i++) {
                if (navLists[i].checked && navLists[i].index == path) {
                    // 如果导航存在checked，并且index等于path，则跳转路由
                    this.$router.push(path);
                    return;
                } else if (navLists[i].subs) {
                    // 如果存在subs
                    for (var j = 0; j < navLists[i].subs.length; j++) {
                        if (navLists[i].subs[j].checked && '/' + navLists[i].subs[j].index == path) {
                            // 如果导航存在checked，并且index等于path，则跳转路由
                            this.$router.push(path);
                            return;
                        }
                    }
                }
            }
        }

        // handleListener() {
        //     bus.$on('collapse', this.handleBus);
        //     // 调用renderChart方法对图表进行重新渲染
        //     window.addEventListener('resize', this.renderChart);
        // },
        // handleBus(msg) {
        //     setTimeout(() => {
        //         this.renderChart();
        //     }, 200);
        // },
        // renderChart() {
        //     this.$refs.bar.renderChart();
        //      .$refs.line.renderChart();
        // }
    }
};
</script>


<style scoped>
.ewCodeNotify .el-card {
    width: 100%;
}
.content-bottom {
    display: flex;
    justify-content: space-between;
}
.ewCodeNotify img {
    max-width: 130px;
    max-height: 130px;
}
.ewCodeNotify {
    display: flex;
    width: 49.6%;
}
.notify-content {
    display: flex;
    width: 90%;
    height: 30px;
    line-height: 30px;
}

.notify-card {
    display: flex;
    width: 50%;
}

.notify-time {
    margin-right: 10px;
    width: 30%;
}
.notify-time-div {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.notify-title {
    width: 50%;
}

.new-notify {
    padding: 10px;
    box-sizing: border-box;
}
.notify-dash {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    box-sizing: border-box;
}
.el-row {
    margin-bottom: 20px;
}

.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
}

.grid-num {
    font-size: 30px;
    font-weight: bold;
}

.grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
}

.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: rgb(242, 94, 67);
}

.grid-con-3 .grid-num {
    color: rgb(242, 94, 67);
}

.user-info {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 20px;
}

.user-avator {
    position: relative;
    width: 120px;
    height: 120px;
    background-color: #409eff;
    border-radius: 50%;
}

.user-avator img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: block;
    width: 100px;
    height: 100px;
}

.user-info-cont {
    flex: 1;
    font-size: 14px;
    color: #999;
}

.user-info-cont div:first-child {
    font-size: 30px;
    color: #222;
}

.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
    margin: 5px 0;
    padding-left: 10px;
    display: flex;
    align-items: center;
}

.user-info-list > span:first-of-type {
    display: inline-block;
    width: 100px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}

.schart {
    width: 100%;
    height: 300px;
}

.quick-access {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.quick-access .access-item-default {
    width: 15%;
    cursor: pointer;
    padding: 20px 10px;
    box-sizing: border-box;
}

.quick-access .access-item-default:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.quick-access .access-item-default div img {
    display: block;
    width: 50px;
    height: 50px;
    margin: 0 auto;
}

.quick-access .access-item-default p {
    text-align: center;
    font-size: 14px;
    margin-top: 20px;
}
/* 九州代驾 */
.quick-access .access-item div {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    background-color: #05c0ab;
    border-radius: 50%;
    margin: 0 auto;
}

/* 陕西羚师傅代驾 */

.quick-access .access-item-ling div {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    background-color: #0ec879;
    border-radius: 50%;
    margin: 0 auto;
}

/* 白师傅 */
.quick-access .access-item-bai div {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    background-color: #0ec879;
    border-radius: 50%;
    margin: 0 auto;
}
/* 马上 */
.quick-access .access-item-ma div {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    background-color: #01c0ab;
    border-radius: 50%;
    margin: 0 auto;
}
/* 青鸟 跟九州用一个颜色 青鸟颜色#34C5B6*/
.quick-access .access-item-bird div {
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    background-color: #05c0ab;
    border-radius: 50%;
    margin: 0 auto;
}


.to-updateCont {
    cursor: pointer;
}

.user-info-name {
    font-size: 18px !important;
}

.statistics-box-head {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}

.statistics-box-head > div > span {
    margin-right: 5px;
    font-size: 14px;
    font-weight: 500;
}

.statistics-box-main {
    display: flex;
    justify-content: center;
}

.statistics-box-main > div {
    max-width: 30%;
    text-align: center;
    width: 150px;
}
/* 九州代驾总单量 总金额按钮颜色 */
.statistics-box-main > div > span {
    font-size: 14px;
    font-weight: 500;
    margin: 0 auto;
    background-color: #05c0ab;
    display: block;
    height: 30px;
    line-height: 30px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
/* 青鸟代驾总单量 总金额按钮颜色 跟九州一个颜色 青鸟APP颜色#34C5B6*/
.statistics-box-main > div > span {
    font-size: 14px;
    font-weight: 500;
    margin: 0 auto;
    background-color: #05c0ab;
    display: block;
    height: 30px;
    line-height: 30px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}


/* 陕西羚师傅代驾样式 */
.ling-box-main > div > span {
    font-size: 14px;
    font-weight: 500;
    margin: 0 auto;
    background-color: #0ec879;
    display: block;
    height: 30px;
    line-height: 30px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
/* 白师傅代驾样式 */
.bai-box-main > div > span {
    font-size: 14px;
    font-weight: 500;
    margin: 0 auto;
    background-color: #0ec879;
    display: block;
    height: 30px;
    line-height: 30px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
/* 马上代驾样式 */
.ma-box-main > div > span {
    font-size: 14px;
    font-weight: 500;
    margin: 0 auto;
    background-color: #01c0ab;
    display: block;
    height: 30px;
    line-height: 30px;
    color: #fff;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}
.statistics-box-main > div > p {
    font-size: 16px;
    font-weight: 800;
    height: 30px;
    line-height: 30px;
    background-color: #eee;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.quick {
    width: calc(100% - 280px);
}

.topUDataProgress {
    font-size: 14px;
    color: #409eff;
    transition: 0.3s;
}

.topUDataProgress:hover {
    color: #e6a51a;
}
.city-main {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: calc(100% - 100px);
}
</style>
